import "./style.scss";
import {
  collection,
  getDocs,
  query,
  Timestamp,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useState, useEffect } from "react";

import { Announcement } from "../../types";

export const Announcements = () => {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);

  const now = Timestamp.fromDate(new Date());

  useEffect(() => {
    const q = query(
      collection(db, "announcements"),
      where("show_until", ">=", now)
    );
    getDocs(q).then((querySnapshot) => {
      setAnnouncements(
        querySnapshot.docs.map((doc) => doc.data() as Announcement)
      );
    });
  }, []);

  // TODO: styling

  return (
    <>
      {announcements.map((announcement) => (
        <div class="announcement">
          <strong>{announcement.title}</strong>
          {announcement.body}
        </div>
      ))}
    </>
  );
};
